//@ts-ignore
import createIndexedDBStorage from 'redux-persist-indexeddb-storage';

const dbName = 'safeguard';
const storage = createIndexedDBStorage(dbName);

const getDataByKey = async (key: string) => {
  const value = await storage.getItem(key);
  return value ? JSON.parse(value) : null;
};

const clearStorage = async () => {
  try {
    await storage.db.clear();
    console.log(`Storage for database "${dbName}" has been cleared.`);
  } catch (error) {
    console.error('Failed to clear storage:', error);
  }
};

export { storage, getDataByKey, clearStorage, dbName };
